import get from 'lodash/get'

class Service {
  /**
   * @name Service#connection
   * @type {Connection}
   */

   /**
   * @name Service#cacheTimeNormal
   * @type {int}
   */

  /**
   * @name Service#eventBus
   * @type {object}
   */

  constructor (connection, cacheTimeNormal = 600) {
    this.connection = connection
    this.cacheTimeNormal = cacheTimeNormal
    this.eventBus = null
  }

  setEventBus (eventBus) {
    this.eventBus = eventBus
  }

  emitTemporaryProblemEvent () {
    if (this.eventBus !== null) {
      this.eventBus.$emit('temporary-problem')
    }
  }

  emitErrorEvent () {
    if (this.eventBus !== null) {
      this.eventBus.$emit('error')
    }
  }

  emitUnauthorizedEvent () {
    if (this.eventBus !== null) {
      this.eventBus.$emit('unauthorized')
    }
  }

  handleEmptyResponse () {
    return Promise.resolve()
  }

  handleSingleRecordResponse (response) {

    return Promise.resolve(response.data.records[0])
  }

  handleSingleRecordResponseWithDefault (response, defaultRecord) {


    if (response.data.records.length === 0) {
      return Promise.resolve(defaultRecord)
    }

    return Promise.resolve(response.data.records[0])
  }

  handleMultiRecordResponse (response, returnRaw = false) {
    console.log('handleMultiRecordResponse')
    console.log(response)
        if (get(response, 'code') === '0' || get(response, 'status') === 200 || get(response, 'data.status.errorCode') === '0') {

      if (returnRaw) {
        return Promise.resolve(response.data)
      }
      else {
        return Promise.resolve(response.data.records)
      }
    }

    return this.handleErrorResponse(response)
  }



  handlePossibleDuplicateErrorResponse (response) {
    console.log('handlePossibleDuplicateErrorResponse')
    console.log(response)
    if (get(response, 'data.status.errorCode') === '1026') {
      return Promise.resolve()
    }

    return this.handleErrorResponse(response)
  }

  handleErrorResponse (response) {
    console.log('handleErrorResponse')
    console.log(response)
    console.log('end response')

    if (typeof response === 'undefined' || !response) {//} == null) {
      return this.emitErrorEvent()
    }
    if (typeof response.message !== 'undefined' && response.message === 'Session not opened' || response.message === `Cannot read property 'length' of undefined`) {
      this.emitUnauthorizedEvent()
    } else {
      if (typeof response.data !== 'undefined' &&
        typeof response.data.status !== 'undefined' &&
        typeof response.data.status.errorCode !== 'undefined'
      ) {
        if (response.data.status.errorCode === 1002) {
          this.emitTemporaryProblemEvent()
        } else if (response.data.status.errorCode === 1054 || response.data.status.errorCode === 1055 || response.data.status.errorCode === 1056 || response.data.status.errorCode === 1009) {
          this.emitUnauthorizedEvent()
        } else {
          this.emitErrorEvent()
        }
      } else {
        this.emitErrorEvent()
      }
    }

    return Promise.reject(response)
  }

  fetchAllRecords (request, params, recordsOnPage = 100, recursive = true) {
    let pageNo = 1

    if (request) {
      return this.fetchRecursive(request, params, recordsOnPage, pageNo, recursive)
    } else {
      return this.fetchRecursivefromErply(params, recordsOnPage, pageNo, recursive)
    }
  }

  fetchRecursive (request, params, recordsOnPage, pageNo, recursive) {
    params.limit = recordsOnPage
    params.page = pageNo

    return this.connection.get(request, params)
      .then(response => this.handleMultiRecordResponse(response))
      .then(records => {
        if (records.length >= recordsOnPage && recursive) {
          return this.fetchRecursive(request, params, recordsOnPage, pageNo + 1, recursive)
            .then(nextRecords => records.concat(nextRecords))
        } else {
          return records
        }
      })
  }

  fetchRecursivefromErply (params, recordsOnPage, pageNo) {
    params.recordsOnPage = recordsOnPage
    params.pageNo = pageNo

    return this.connection.postErply(params)
        .then(response => this.handleMultiRecordResponse(response))
        .then(records => {
          if (records.length >= recordsOnPage) {
            return this.fetchRecursivefromErply(params, recordsOnPage, pageNo + 1)
              .then(nextRecords => records.concat(nextRecords))
          } else {
            return records
          }
        })
  }
}
export default Service



// WEBPACK FOOTER //
// ./src/api/Service/Service.js